<template>
  <div>
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <form>
      <div class="p-grid">
        <div class="p-col">
          <!-- <Button class="p-button-raised p-mr-2" style="float: right" @click.prevent="openBasic"
                  icon="pi pi-plus"/> -->
          <Button class="p-button p-component addNewBtn btn-btm-0"  @click.prevent="openBasic" label="NEW"/>
        </div>
      </div>
      <Dialog header="Account Group" :visible.sync="displayBasic"
              :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">

        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
            <label for="name">Name<span style="color:red">*</span></label>
            <InputText type="text" ref="name" v-model.trim="accName"/>
          </div>
        <!-- </div> -->
        <!-- <div class="p-fluid p-formgrid p-grid"> -->
          <div class="p-field p-col-12 p-md-6">
            <label for="nature">Account Nature<span style="color:red">*</span></label>
            <Dropdown v-model="natureId" :options="accNatureList" optionLabel="name" placeholder="Select Nature"
                      :filter="true"
                      :showClear="true" id="nature"/>
          </div>
        </div>
        <template #footer>
          <Button class="p-button-raised p-button-rounded" :label="editing?'Update':'Add'"
                  @click.prevent="addAccountHead"/>
          <Button class="p-button-raised p-button-info" v-if="!editing" label="Add & New"
                  @click.prevent="saveAndNewAccountGroup"/>
          <Button class="p-button-raised p-button-danger" label="Cancel" @click.prevent="cancel"/>
        </template>
      </Dialog>
    </form>
  </div>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
// import Toast from 'primevue/toast'

export default {
  name: 'accountgroup',
  data() {
    return {
      natureId: '',
      accName: '',
      accNatureList: [],
      editing: false,
      id: null,
      loading: false,
      displayBasic: false
    }
  },
  created() {
    this.natureList()
  },
  methods: {
    async addAccountHead() {
      if (this.accName.trim() === '' || this.natureId === '' || this.natureId === null) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Data must not be empty!', life: 10000})
        return
      }
      let response = ''
      let accountHead = {
        name: this.accName,
        accountNatureId: this.natureId.id,
        id: this.id
      }
      this.loading = !this.loading
      try {
        if (!this.editing) {
          response = await this.$store.dispatch('createAccountHead', accountHead)
          this.$emit('set_data', response.data.data)
          this.loading = false
        } else {
          this.loading = !this.loading
          response = await this.$store.dispatch('updateAccountHead', accountHead)
          this.loading = false
        }
      } catch (e) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!!', life: 10000})
        this.loading = false
        return
      }
      this.responseCheck(response)
      this.closeBasic()
    },
    async saveAndNewAccountGroup() {
      if (this.accName.trim() === '' || this.natureId === '' || this.natureId === null) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Data must not be empty!', life: 10000})
        return
      }
      let accountHead = {
        name: this.accName,
        accountNatureId: this.natureId.id,
        id: this.id
      }
      let response = ''
      try {
        this.loading = !this.loading
        response = await this.$store.dispatch('createAccountHead', accountHead)
      } catch (e) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!!', life: 10000})
        this.loading = false
        return
      }

      this.responseCheck(response)
      this.focusAfterSave()
    },
    async natureList() {
      let response = await this.$store.dispatch('loadAccountNatureList')
      this.accNatureList = response.data.data
    },
    responseCheck(response) {
      if (response.data.status === 'ERROR') {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
        this.reset()
        return
      } else {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        this.reset()
        return
      }
    },
    openDialog(data) {
      this.editing = true
      this.accName = data.name
      this.natureId = data.accountNature
      this.id = data.id
      this.openBasic()
    },
    cancel() {
      this.accName = ''
      this.natureId = ''
      this.editing = false
      this.closeBasic()
    },
    reset() {
      this.natureId = ''
      this.accName = ''
      this.editing = false
    },
    openBasic() {
      this.displayBasic = true
    },
    closeBasic() {
      this.displayBasic = false
    },
    focusAfterSave() {
      this.$nextTick(function () {
        this.$refs.name.$el.focus()
      })
    }
  },
  components: {
    Dialog,
    Dropdown,
    Button,
    InputText
    // Toast
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// AccountGroupDialog.vue?381cea6e